import React, { Component } from 'react';

class ClockLiveTime extends Component{
    constructor(props) {
        super(props);
        this.state = {
            interval: 0,
            fullTime: ''
        }
    }

    componentDidMount(){

        let interval = setInterval( () => this.setState({
            fullTime: `${this.checkTime(new Date().getHours())}:${this.checkTime(new Date().getMinutes())}:${this.checkTime(new Date().getSeconds())}`
        }), 1000 );
        this.setState({interval : interval});
    }

    componentWillUnmount(){
        clearInterval(this.state.interval);
    }

    checkTime = (i) =>{
        return i < 10 ? i = "0" + i : i;
    }

    render(){
        return(
            <h2>{this.state.fullTime}</h2>
        );
    }

}

export default ClockLiveTime;